
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]/claim",
      function () {
        return require("private-next-pages/[insuranceType]/claim/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insuranceType]/claim"])
      });
    }
  